import { motion } from "framer-motion";
import { FiCheckCircle } from "react-icons/fi";

const principles = [
  "Clarity before code",
  "Premium interface quality",
  "Startup speed execution",
  "Engineering with launch intent",
  "Ownership beyond handoff",
  "Original product thinking",
];

export default function About() {
  return (
    <main className="premium-page">
      <section className="premium-shell">
        <motion.div
          initial={{ opacity: 0, y: 18 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6 }}
          className="flex flex-col items-center gap-10 text-center"
        >
          <div>
            <p className="eyebrow">About Code7s</p>
            <h1 className="hero-heading mt-5">
              A studio for founders who want to ship with taste.
            </h1>
          </div>
          <div className="premium-card max-w-4xl rounded-[28px] p-6 text-center md:p-8">
            <p className="text-lg leading-8 text-neutral-700">
              Code7s helps startups, founders, and businesses turn ideas into
              real software products. We work across startup strategy, product
              design, UX UI systems, mobile app development, web development,
              SaaS builds, launch support, and post launch improvement for
              apps, websites, platforms, dashboards and tools.
            </p>
            <p className="mt-6 text-lg leading-8 text-neutral-700">
              Because we also publish apps and tools under Code7s, we approach
              every project with product ownership: what should exist, how it
              should feel, what can launch first, and how it can keep improving.
            </p>
          </div>
        </motion.div>

        <div className="mt-16 grid gap-5 sm:grid-cols-2 lg:grid-cols-3">
          {principles.map((item, index) => (
            <motion.div
              key={item}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.4, delay: index * 0.05 }}
              className="premium-card rounded-[22px] p-5"
            >
              <FiCheckCircle className="text-2xl text-emerald-600" aria-hidden="true" />
              <h2 className="mt-6 text-xl font-bold tracking-tight">{item}</h2>
            </motion.div>
          ))}
        </div>

        <section className="glass-card mt-20 rounded-[32px] p-6 text-center md:p-10">
          <div className="mx-auto max-w-4xl">
            <p className="section-kicker">Founder note</p>
            <h2 className="section-heading mt-3">
              Good products need more than development.
            </h2>
            <p className="mx-auto mt-6 max-w-3xl text-lg leading-8 text-neutral-700">
              Too many ideas fail because the execution starts before the
              product is clear. Code7s exists to combine creative direction,
              design discipline, and engineering into one focused launch path.
            </p>
          </div>
        </section>
      </section>
    </main>
  );
}
